import { InputAdornmentButton } from '@cian/ui-kit';
import { FDealType } from '../../../../../../packages/JsonQuery';
import { useSelector } from 'react-redux';
import { selectDealType } from 'shared/selectors/jsonQuery';
import {
  selectHasDistricts,
  selectHasHighways,
  selectHasRegionalDistricts,
  selectHasUnderground,
} from 'shared/selectors/location';
import { DirectionsModalContainer } from '../ModalContainer';
import { useAppDispatch, useModalState } from 'shared/hooks';
import { useCallback } from 'react';
import { loadDirectionsData } from 'shared/thunks/geo/directions';
import { selectNeedDirectionsDataRequest } from 'shared/selectors/geo';

export const DirectionsPopupButtonContainer = () => {
  const dispatch = useAppDispatch();
  const dealType = useSelector(selectDealType);
  const hasUnderground = useSelector(selectHasUnderground);
  const hasDistricts = useSelector(selectHasDistricts);
  const hasRegionalDistricts = useSelector(selectHasRegionalDistricts);
  const hasHighways = useSelector(selectHasHighways);
  const needDirectionsDataRequest = useSelector(selectNeedDirectionsDataRequest);

  const { opened, onClose, onOpen } = useModalState();

  const handleOpen = useCallback(() => {
    onOpen();

    if (needDirectionsDataRequest) {
      dispatch(loadDirectionsData());
    }
  }, [dispatch, needDirectionsDataRequest, onOpen]);

  if (!hasHighways || (dealType === FDealType.RentDaily && hasUnderground) || (hasDistricts && !hasRegionalDistricts)) {
    return null;
  }

  return (
    <>
      <InputAdornmentButton type="button" onClick={handleOpen}>
        Шоссе
      </InputAdornmentButton>
      {opened && <DirectionsModalContainer onModalClose={onClose} />}
    </>
  );
};
